import * as React from "react";
import { connect } from "react-redux";
import { selectIsGridVisible } from "../../selectors/selectExistingBuildingInfo";
import { selectIsHudVisible } from "../../selectors/selectIsHudVisible";
import { NavigationModeContainer } from "./NavigationModeContainer";
import { PlacementModeContainer } from "./PlacementModeContainer";
var HudNavigationDOM = function (_a) {
    var isGridVisible = _a.isGridVisible, shouldRender = _a.shouldRender;
    // If grid is visible building is in placement mode and placementMode buttons should be shown
    if (!shouldRender && !isGridVisible) {
        return React.createElement(React.Fragment, null);
    }
    return isGridVisible ? React.createElement(PlacementModeContainer, null) : React.createElement(NavigationModeContainer, null);
};
var mapState = function (state) { return ({
    isGridVisible: selectIsGridVisible(state),
    shouldRender: selectIsHudVisible(state),
}); };
export var HudNavigation = connect(mapState)(HudNavigationDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/navigation/HudNavigation.tsx
// module id = 2264
// module chunks = 3